import React, { useState } from 'react'
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    IconButton,
    Input,
    Text,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Switch,
    Tooltip,
} from '@chakra-ui/react'
import { VscEdit } from 'react-icons/vsc'
import { useDispatch } from 'react-redux';
import { updatePais, getPaises } from '../../features/paisSlice';

export const ModalEditarPais = ({ row, page, perPage }) => {

    const dispatch = useDispatch();

   // const user = useSelector(state => state.auth.user);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const initialValues = {
        descripcion: '',
        estado: null,
    }

    const [indice, setIndice] = useState(initialValues);

    const handleModalOpen = (data) => {
        setIsModalOpen(true);
        setIndice({ ...data }); // ✅ Clona el objeto para evitar referencias circulares
    };

    const handleModalClose = () => {
        setIsModalOpen(false)
    }

    /*const handleUpdate = () => {
        dispatch(updatePais(indice));
        setIsModalOpen(false)
    }*/
    const handleUpdate = (indice) => {
        dispatch(updatePais(indice)).then(() => {
            dispatch(getPaises({ page, perPage })); // Usa los valores pasados como props y Actualiza la tabla después de eliminar
            setIsModalOpen(false); // Cierra el modal
        });
    };
    

    return (
        <>
            <Tooltip hasArrow label='Editar' placement='auto'>
                <IconButton
                    colorScheme="blackAlpha"
                    _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                    aria-label="Editar"
                    icon={<Icon as={VscEdit}
                        fontSize="2xl" />}
                    variant="ghost"
                    onClick={() => handleModalOpen(row)}
                    ml={2}
                />
            </Tooltip>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">ACTUALIZAR PAIS</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Stack spacing={4} direction="column" justifyContent="space-between" p={4}>
                        

                            <Stack spacing={4} direction="row" justifyContent="space-between">
                                <FormControl
                                >
                                    <FormLabel fontWeight="semibold">ID</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.id : ''}
                                        placeholder="Escribe la descripcion"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, id: e.target.value })}
                                        isReadOnly // Esto bloquea el campo ID, no permitiendo su edición
                                    />
                                </FormControl>
                                <FormControl>
                                    <FormLabel fontWeight="semibold">Descripcion</FormLabel>
                                    <Input
                                        defaultValue={indice ? indice.descripcion : ''}
                                        placeholder="Escribe la descripcion"
                                        type="text"
                                        onChange={(e) => setIndice({ ...indice, descripcion: e.target.value })}
                                    />
                                </FormControl>
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" w="full">
                                <Text fontWeight="semibold">ESTADO</Text>
                                <Switch onChange={(e) => setIndice({ ...indice, estado: e.target.checked })} value={indice ? indice.estado : null} colorScheme="purple" isChecked={indice.estado === true ? true : false} size='lg' />
                            </Stack>
                     
                   
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="red"
                            _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleModalClose}
                            borderRadius="xl"
                        >
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="green"
                            _dark={{ bg: "green.600", color: "white", _hover: { bg: "green.800" } }}
                            size="lg"
                            mr={3}
                            onClick={() => handleUpdate(indice)} // ✅ Ahora pasa `indice`
                            borderRadius="xl"
                        >
                            ACTUALIZAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
